export const ACTIVITY_STATUS_CONFIRMED = Symbol('ACTIVITY_STATUS_CONFIRMED')
export const ACTIVITY_STATUS_FAILED = Symbol('ACTIVITY_STATUS_FAILED')
export const ACTIVITY_STATUS_PENDING = Symbol('ACTIVITY_STATUS_PENDING')
export const ACTIVITY_STATUS_TIMED_OUT = Symbol('ACTIVITY_STATUS_TIMED_OUT')
